import React from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

type PropsType = {
  defaultValues?: any;
  children?: any;
  onSubmit?: any;
  schema?: any;
  getValues?: any;
  className?: string;
  reset?: boolean;
};
const Form: React.FC<PropsType> = ({
  defaultValues,
  children,
  onSubmit,
  schema = yup.object({}),
  // getValues,
  className,
  reset = false,
}) => {
  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues,
    // getValues,
    resolver: yupResolver(schema),
  });

  const { handleSubmit } = methods;

  const CheckInside = (children: any, methods: any) => {
    return children.map(
      (child: {
        props: { passProps: any; name: any; children: any };
        type: any;
      }) => {
        if (typeof child === "object") {
          if (child.props.passProps) {
            return React.createElement(child.type, {
              ...{
                ...child.props,
                register: methods.register,
                watch: methods.watch,
                setValue: methods.setValue,
                key: child.props.name,
                errors: methods.formState.errors,
                clearErrors: methods.clearErrors,
                control: methods.control,
                getValues: methods.getValues,
                formState: methods.formState,
                reset: methods.reset,
              },
            });
          } else if (child.props.name) {
            return React.createElement(child.type, {
              ...{
                ...child.props,
                register: methods.register,
                watch: methods.watch,
                setValue: methods.setValue,
                key: child.props.name,
                errors: methods.formState.errors,
                clearErrors: methods.clearErrors,
                control: methods.control,
                getValues: methods.getValues,
                reset: methods.reset,
              },
            });
          } else if (
            typeof child.props.children === "object" &&
            !Array.isArray(child.props.children)
          ) {
            return React.createElement(child.type, {
              ...child.props,
              children: CheckInside([child.props.children], methods),
            });
          } else if (
            Array.isArray(child.props.children) &&
            child.props.children
          ) {
            return React.createElement(child.type, {
              ...child.props,
              children: CheckInside(child.props.children, methods),
            });
          } else {
            return {
              ...child,
              register: methods.register,
              watch: methods.watch,
              setValue: methods.setValue,
              key: child.props.name,
              errors: methods.formState.errors,
              clearErrors: methods.clearErrors,
              control: methods.control,
              getValues: methods.getValues,
              reset: methods.reset,
            };
          }
        } else {
          return child;
        }
      }
    );
  };

  return (
    // <FormProvider {...methods}>
    <form
      onSubmit={
        reset
          ? handleSubmit(async (data: any, e: any) => {
              await onSubmit(data, e, methods.reset)?.then(() => {
                methods.reset(data, {});
                e.target.reset();
              });
            })
          : handleSubmit(async (data: any, e: any) => {
              await onSubmit(data, e, methods.reset)?.then(() => {
                /*   methods.reset(data, {});
          e.target.reset(); */
              });
            })
      }
      className={className}
    >
      {CheckInside(!Array.isArray(children) ? [children] : children, methods)}
    </form>
    // </FormProvider>
  );
};

export default Form;
